import React, { useContext, useState } from 'react';
import { ModalBottomButtonContainer } from './Styles';
import { DangerButton, SuccessButton } from '../connectedForm/Button';
import ModalContext from '../Context/ModalContext';
import ConnectedFormContext from '../Context/ConnectedFormContext';
import { BasicHeader } from '../../actions/BasicHeader';
import Fieldset from '../connectedForm/Fieldset';
import { todaysDate } from '../../utils/DateHelper';
import {
  IAutomatedCreditControlRunMutationResult,
  IAutomatedCreditControlRunMutationVariables,
  IAutomatedCreditControlWorkflow,
} from '../../graphql/schema/p4types';
import { DateField } from '../connectedForm/inputComponents';
import { IJobMeta, useBackgroundMutation } from '../../utils/BackgroundJobs';
import { AutomatedCreditControlRunMutation } from '../../graphql/mutations/salesLedger/AutomatedCreditControlRunMutation.graphql';
import { AutomatedCreditControlResult } from '../../graphql/entities';
import getClientMutationId from '../../utils/getClientMutationId';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import FluentModal from './FluentModal';

type Props = {
  isOpen: boolean;
  isPreview: boolean;
};

const AutomatedCreditControlRunWorkflowModal = ({ isOpen, isPreview }: Props) => {
  const connectedForm = useContext(ConnectedFormContext);
  const workflow = connectedForm.values as IAutomatedCreditControlWorkflow;
  const { onClose } = useContext(ModalContext);

  // state
  const [baseDate, setBaseDate] = useState<string>(todaysDate());

  const onConfirm = () => {
    onClose?.();
    runWorkflowMutation({
      variables: {
        input: {
          clientMutationId: getClientMutationId(),
          baseDate: baseDate,
          workflow: normalizeVariables(workflow),
          isPreview: isPreview,
        },
      },
    });
  };

  const onGenerationComplete = (job: IJobMeta) => {
    const path = `${AutomatedCreditControlResult.workspaceUrl}${job.jobId}`;
    window.open(window.location.origin + path, '_blank');
  };

  const [runWorkflowMutation] = useBackgroundMutation<
    IAutomatedCreditControlRunMutationResult,
    IAutomatedCreditControlRunMutationVariables
  >(AutomatedCreditControlRunMutation, {
    onCompleteJob: (job) => {
      onGenerationComplete(job);
    },
  });

  const prefix = isPreview ? 'Preview: ' : 'LIVE RUN:  ';

  return (
    <FluentModal isOpen={isOpen} styles={{ main: { minWidth: '700px', paddingBottom: '100px' } }}>
      <BasicHeader>{`${prefix} ${workflow.name} Workflow`}</BasicHeader>
      <Fieldset cols={1}>
        {!isPreview ? (
          <p>
            This is a live run. <b>Tasks and Emails will be created for any qualifying transactions.</b>
          </p>
        ) : null}
        <DateField
          label="Base date"
          value={baseDate}
          onChange={setBaseDate}
          hint="Preview the workflow based on payment due compared to this date"
          labelCols={4 / 12}
          inputCols={8 / 12}
          data-testid={'workflowPreview-baseDate'}
        />
      </Fieldset>
      <ModalBottomButtonContainer>
        <DangerButton data-testid="workflowPreview-cancel" onClick={onClose}>
          Cancel
        </DangerButton>
        <SuccessButton data-testid="workflowPreview-confirm" onClick={onConfirm}>
          Confirm
        </SuccessButton>
      </ModalBottomButtonContainer>
    </FluentModal>
  );
};

export default AutomatedCreditControlRunWorkflowModal;
